/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ left: NonNullable<unknown>, right: NonNullable<unknown> }} Body_Assessment_Compare_Method_NoteInputs */

const en_us2_body_assessment_compare_method_note = /** @type {(inputs: Body_Assessment_Compare_Method_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`The methods were different: ${i?.left} and ${i?.right}. Part of the difference may come from that.`)
};

const pt_br2_body_assessment_compare_method_note = /** @type {(inputs: Body_Assessment_Compare_Method_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Os métodos foram diferentes: ${i?.left} e ${i?.right}. Parte da diferença pode vir daí.`)
};

const es_419_body_assessment_compare_method_note = /** @type {(inputs: Body_Assessment_Compare_Method_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Los métodos fueron diferentes: ${i?.left} y ${i?.right}. Parte de la diferencia puede venir de ahí.`)
};

const pt_pt2_body_assessment_compare_method_note = /** @type {(inputs: Body_Assessment_Compare_Method_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Os métodos foram diferentes: ${i?.left} e ${i?.right}. Parte da diferença pode vir daí.`)
};

const fr_fr2_body_assessment_compare_method_note = /** @type {(inputs: Body_Assessment_Compare_Method_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Les méthodes étaient différentes : ${i?.left} et ${i?.right}. Une partie de l'écart peut venir de là.`)
};

const de_de2_body_assessment_compare_method_note = /** @type {(inputs: Body_Assessment_Compare_Method_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Die Methoden waren unterschiedlich: ${i?.left} und ${i?.right}. Ein Teil des Unterschieds kann daher kommen.`)
};

const it_it2_body_assessment_compare_method_note = /** @type {(inputs: Body_Assessment_Compare_Method_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`I metodi erano diversi: ${i?.left} e ${i?.right}. Parte della differenza può venire da lì.`)
};

/**
* | output |
* | --- |
* | "The methods were different: {left} and {right}. Part of the difference may come from that." |
*
* @param {Body_Assessment_Compare_Method_NoteInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_compare_method_note = /** @type {((inputs: Body_Assessment_Compare_Method_NoteInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Compare_Method_NoteInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_compare_method_note(inputs)
	if (locale === "es-419") return es_419_body_assessment_compare_method_note(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_compare_method_note(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_compare_method_note(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_compare_method_note(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_compare_method_note(inputs)
	return en_us2_body_assessment_compare_method_note(inputs)
});
export { body_assessment_compare_method_note as "body-assessment.compare_method_note" }